import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useDevice } from '../../../contexts/DeviceContext';
import { getCurrentLayout } from '../../../utils/ChooseLayout';
import { useLocale } from '../../../contexts/LocaleProvider';
import NewsTab from './NewsTab';
import './whatsNews.css';
import { useResponsive } from '../../../contexts/ResponsiveContext';
import { TabDivider } from '../../common/TabDivider';

function CustomTabPanel(props: { children?: React.ReactNode; index: number; value: number }) {
    const { children, value, index, ...other } = props;
    const { isScreenXs } = useResponsive(); // 取得螢幕尺寸資訊

    // 當螢幕尺寸為 xs 時，設定 padding 為 0，否則使用預設值 p: 3
    const panelPadding = isScreenXs ? '1rem 0' : 3;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: panelPadding }}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function WhatsNew() {
    const [value, setValue] = useState(0);
    const { width } = useDevice();
    const layout = getCurrentLayout(width);
    const { locale } = useLocale();

    const StyledTab = styled(Tab)({
        '&.Mui-selected': {
            color: 'black',
        },
        paddingLeft: '0.3rem',
        fontWeight: 400,
        fontFamily: 'Poppins',
        textTransform: 'none',
    });

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const { isScreenXs, responsiveWidth } = useResponsive();

    return (
        <div className="whats-new-container">
            <Box
                data-testid={'whatsnew-header'}
                sx={{
                    paddingTop: '2rem',
                    width: isScreenXs ? responsiveWidth : undefined,
                    mx: 'auto',
                }}
            >
                <Typography>
                    <span className="font_whatsNew">
                        <FormattedMessage id="WhatsNew" defaultMessage="What's New" />
                    </span>
                </Typography>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    TabIndicatorProps={{
                        style: {
                            top: '20',
                            backgroundColor: '#E5673E',
                            height: 3,
                        },
                    }}
                    aria-label="What's New with YAGEO"
                    sx={{ marginLeft: isScreenXs ? undefined : '2rem', position: 'relative' }}
                    data-testid={'whatsnew-tab'}
                >
                    <StyledTab
                        sx={{
                            fontSize:
                                layout === 'extra_small' && locale === 'de' ? '1rem' : '1.25rem',
                        }}
                        label={<FormattedMessage id="NewProducts" defaultMessage="New Products" />}
                        {...a11yProps(0)}
                    />
                    <StyledTab
                        sx={{
                            fontSize:
                                layout === 'extra_small' && locale === 'de' ? '1rem' : '1.25rem',
                        }}
                        label={<FormattedMessage id="LastestNews" defaultMessage="Latest News" />}
                        {...a11yProps(1)}
                    />
                    <TabDivider
                        sx={{
                            position: 'absolute',
                            border: 3,
                            top: '95%',
                            borderColor: 'divider',
                            width:
                                layout === 'small'
                                    ? '94%'
                                    : layout === 'extra_small'
                                      ? '100%'
                                      : '96%',
                        }}
                    />
                </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0} data-testid={'tab-panel-1'}>
                <Box
                    sx={{
                        width: isScreenXs ? responsiveWidth : undefined,
                        mx: 'auto',
                    }}
                    data-testid={'tab1'}
                >
                    <NewsTab filterKeys={['News/Product']} />
                </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1} data-testid={'tab-panel-1'}>
                <Box
                    sx={{
                        width: isScreenXs ? responsiveWidth : undefined,
                        mx: 'auto',
                    }}
                    data-testid={'tab2'}
                >
                    <NewsTab filterKeys={['News/Corporate', 'News/Financial']} />
                </Box>
            </CustomTabPanel>
        </div>
    );
}
